"use client";

import {useHydrateAtoms} from "jotai/utils";
import type {ReactNode} from "react";
import type {DiscoveryAuthUser} from "@/lib/getDiscoveryAuth";
import {discoveryUserAtom} from "./discoveryUser";

export function HydrateDiscoveryUser({
	user,
	children,
}: {
	user: DiscoveryAuthUser | null;
	children: ReactNode;
}) {
	useHydrateAtoms([[discoveryUserAtom, user]]);
	return children;
}
